<div class="mt-1">
    <div class="description my-1">Please complete the Alternative Class A general information below</div>
    <div class="container">
        <form [formGroup]="interalForm">
            <div class="row form-group">
                <div class="col-sm-12 col-md-6">
                    <app-form-control type="select" [form]="interalForm" title="Program Level"
                        placeholder="Program Level" controlName="programType" [data]="programTypes"></app-form-control>
                </div>
                <div class="col-sm-12"></div>
                <div class="col-sm-12 col-md-6">
                    <app-form-control type="date" [form]="interalForm" title="Date of Unconditional Admission" placeholder="Date of Unconditional Admission"
                        controlName="admissionDate" ></app-form-control>
                </div>
                <div class="col-sm-12 col-md-6">
                    <app-form-control type="date" [form]="interalForm" title="Program Completion Date" placeholder="Program Completion Date"
                        controlName="completionDate" [maxDate]="maxDate"></app-form-control>
                </div>
                <div class="col-sm-12 col-md-6">
                    <app-form-control type="text" [form]="interalForm" title="Admission Degree GPA" 
                        placeholder="Admission Degree GPA" controlName="degreeGPA"></app-form-control>
                </div>
                <div class="col-sm-12 col-md-6">
                    <app-form-control type="text" [form]="interalForm" title="Approved Program GPA" 
                        placeholder="Approved Program GPA" controlName="programGPA"></app-form-control>
                </div>
            </div>
        </form>
    </div>
</div>